// @module NVT.AssociateMembershipForm.ReviewSubmission
define('NVT.AssociateMembershipForm.ReviewSubmission.View'
,	[
		'review_submission.tpl'
		
	,	'Backbone'

    ]
, function (
		review_submission_tpl
	
	,	Backbone

)
{
    'use strict';

	// @class NVT.AssociateMembershipForm.ReviewSubmission.View @extends Backbone.View
	return Backbone.View.extend({

		template: review_submission_tpl

	,	initialize: function (options) {

			this.options = options;
			this.container = options.container;
			var self = this;				
		}

	,	events: {

		}

	,	bindings: {

		}

		//@method getContext @return NVT.ReviewSubmission.ReviewSubmission.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			
			return {
				iscontinueDataFlow : this.options.continueDataFlow || '',
			};
		}
	});
});
